// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__JusQF","tagList":"Tags_tagList__EuhUF","tag":"Tags_tag__4s6Ev","gray":"Tags_gray__I2HY0"};